
document.querySelector('.next-arrow').addEventListener('click', () => {
  const activeItem = document.querySelector('.thumb-item.active');
  if (activeItem) {
    let nextItem = activeItem.nextElementSibling;
    if (!nextItem || !nextItem.classList.contains('thumb-item')) {
      // Loop back to the first .thum-item
      nextItem = document.querySelector('.thumb-item');
    }
    if (nextItem) {
      nextItem.click();
    }
  }
});


// document.addEventListener('DOMContentLoaded', () => {

//   FoxTheme.pubsub.subscribe(
//     FoxTheme.pubsub.PUB_SUB_EVENTS.variantChange,
//     ({ data }) => {

//       const variant = data?.variant;
//       if (!variant || !variant.featured_media) return;

//       const position = variant.featured_media.position;

//       console.log('✅ Move to:', position);

//       const swiper = document.querySelector('.product__media-gallery .swiper')?.swiper;

//       if (!swiper) {
//         console.warn('Swiper not found');
//         return;
//       }

//       swiper.slideToLoop(position - 1);
//     }
//   );

// });